import React from 'react'
import PropTypes from 'prop-types'
import createStyles from './styles'
import { OptionsHOC } from '../../hocs'

const proptypes = {
  show: PropTypes.bool.isRequired,
  text: PropTypes.string,
  getOption: PropTypes.func.isRequired
}

let LinkTextBox = ({ show, text = '', getOption }) => {
  let styles = createStyles(getOption)
  let showStyle = () => {
    return {
      display: show ? 'inline' : 'none'
    }
  }

  text = text === null ? '' : text

  return (
    <div style={showStyle()}>
      <input style={styles.base} type="text" value={text} readOnly />
    </div>
  )
}

LinkTextBox.propTypes = proptypes

export default OptionsHOC(LinkTextBox)



// WEBPACK FOOTER //
// ./src/components/LinkTextBox/LinkTextBox.js